import { render, staticRenderFns } from "./payment-card.vue?vue&type=template&id=26272a30&"
import script from "./payment-card.vue?vue&type=script&lang=js&"
export * from "./payment-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports